import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.FeaturePadlocks1,
  LocationVarKey.FeaturePadlocks2,
  LocationVarKey.DaVinciCodeDeliveryChannel,
  LocationVarKey.DaVinciCodeSMSMessage
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Padlock Access
      </PageHeader>

      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasPadlocks, "1")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.FeaturePadlocks1}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasPadlocks, "1")}
        marginTop
        label=" Message 2"
        keyName={LocationVarKey.FeaturePadlocks2}
      />

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasDaVinciCodeIntegration, "1")}>
        Delivery Settings
      </SectionHeader>
      <DropdownRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasDaVinciCodeIntegration, "1")}
        marginTop
        label=" Send DaVinci Code to:"
        keyName={LocationVarKey.DaVinciCodeDeliveryChannel}
        options={[
          {
            label: "SMS",
            value: "SMS"
          },
          {
            label: "Email",
            value: "Email"
          },
          {
            label: "SMS and Email",
            value: "Both"
          }
        ]}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.DaVinciCodeDeliveryChannel, "Email") && IS_NOT_EQUAL(LocationVarKey.HasDaVinciCodeIntegration, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.DaVinciCodeSMSMessage}
      />
    </>
  );
}
